import { action, computed, observable, observe, toJS } from 'mobx';
import { AlertProps } from 'components/antd/Alert/Alert';
import { getErrorMsg } from 'utils/utils';

type AlertTypes = AlertProps['type'];
export type MessageAlert = string | string[] | null;
interface AlertMessage {
	type: AlertTypes;
	message: MessageAlert;
}

export class AlertStore {
	@observable
	private _alert: AlertMessage = {
		message: null,
		type: undefined,
	};

	constructor() {
		observe(this, 'alert', ({ newValue }) => {
			const { message } = newValue;
			if (message) {
				setTimeout(this.clearAlert, 5000);
			}
		});
	}

	@computed
	get alert() {
		return toJS(this._alert);
	}

	@action.bound
	setAlert(message: MessageAlert, type: AlertTypes) {
		this._alert = {
			type,
			message,
		};
	}

	@action.bound
	setErrorAlert(message: MessageAlert) {
		this._alert = {
			type: 'error',
			message,
		};
	}

	@action.bound
	setRequestError(error: Error) {
		this.setErrorAlert(getErrorMsg(error));
	}

	@action.bound
	clearAlert() {
		this._alert = {
			type: undefined,
			message: null,
		};
	}
}
